export default {
  Table_Common: {
    TuoDong: '拖動',
    ZhuanJieMa_MingCheng: '轉介碼名稱',
    ZhuanJie_Ma: '轉介碼',
    TingYon_ZhuanTai: '停用狀態',
    ChuangJian_ShiJian: '創建時間',
    DengLu_ShiJian: '登錄時間',
    YongHu: '用戶',
    DengLu: '登錄',
    DengChu: '登出',
    PiLiang_TiChu: '批量踢出',
    ChengGong: '成功',
    ShiBai: '失敗',
    CuoWu_Ma: '錯誤碼',
    DengLu_IP: '登錄IP',
    JiaZai_Zhong: '加載中',
    ShouJi_HaoMa: '手機號碼',
    DianHua: '電話',
    XingBie: '性別',
    ZhiGong_LeiBie: '職工類別',
    ZhenJin: '診金',
    Yuan: '元',
    JueSe: '角色',
    ShuJu_QuanXian: '數據權限',
    QuanXian_FanWei: '權限範圍',
    ShiYong_ZhenSuo: '適用診所',
    YuanGong_ZhuangTai: '員工狀態',
    QiYong: '啓用',
    TingYong: '停用',
    ShiFou_CanYu_PaiBan: '是否參與排班',
    ShiFou_PaiBan: '是否排班',
    Shi: '是',
    Fou: '否',
    PaiBan: '排班',
    YouXiang: '郵箱',
    ChuSheng_RiQi: '出生日期',
    CaoZuo: '操作',
    Nan: '男',
    Nv: '女',
    MiaoShu: '描述',
    CaiDan_MingCheng: '菜單名稱',
    LuYou: '路由',
    GongNeng_QuanXian: '功能權限',
    YaoFei: '藥費',
    ZhenJiu_JinE: '針灸金額',
    TaoPiao: '套票',
    YouFei: '郵費',
    ZhenJin_JinE: '診金金額',
    TuiNa_ZhengGu: '推拿/正骨',
    BaGuan_JinE: '拔罐金額',
    YouHuiQuan_MingCheng: '優惠券名稱',
    QiYong_ZhuangTai: '啟用狀態',
    MianE: '面額',
    ManJian_MuBiao_JinE: '滿減目標金額',
    ShiYong_QingKuang: '使用情況',
    Yi_ShiYong: '已使用',
    Yi_Shou: '已售',
    ShiFou_YiShou: '是否已售',
    Yi_FaFang: '已發放',
    ShiYong_DanJu: '適用單據',
    GuoQi_ShiJian: '過期時間',
    ShiYong_GuoQi_ShiJian: '使用過期時間',
    YouXiaoQi: '有效期',
    ChangQiYouXiao: '長期有效',
    FaFangQi_ShiChang: '發放起 {duration}{unit}',
    GouMaiQi_ShiChang: '購買起 {duration}{unit}',
    Zhi_RiQi: '至 {date}',
    ShouMai_ShiJian: '售賣時間',
    ShouMai_JieShu: '{date}結束',
    GuoQi_RiQi: '過期日期',
    HuanZhe_XingMing: '患者姓名',
    LaiYuan: '來源',
    YiShi_Duan: '醫師端',
    GuanLi_Duan: '管理端',
    JianDang_ShiJian: '建檔時間',
    ShouHuo_Ren: '收貨人',
    YiDong_SheZhi: '移動設置',
    MoRen_DiZhi: '默認地址',
    SheWei_MoRen: '設為默認',
    ChanPin_MingCheng_En: '產品名稱(EN)',
    YaoPin_MingCheng_En: '藥品名稱(En)',
    BianMa: '編碼',
    GuiGe_En: '規格(EN)',
    NongSuo: '濃縮',
    JingZhong: '淨重',
    DanWei_ChengBen_Jia: '單位成本價',
    DanWei_ShouJia: '單位售價',
    KuCun: '庫存',
    ChuFang_DanWei: '處方單位',
    YaoPin_ZhuangTai: '藥品狀態',
    GuiGe_ZhuangTai: '規格狀態',
    ChengFen_Yao: '成分藥',
    DingDan_ZhuangTai: '訂單狀態',
    DingDan_JinE: '訂單金額',
    XiaDan_Ren: '下單人',
    ShenPi_Ren: '審批人',
    GengXin_ShiJian: '更新時間',
    ShenPi_ShiJian: '審批時間',
    ChengBen_Jia: '成本價',
    XiaDan_ShuLiang: '下單數量',
    QianShou_ShuLiang: '簽收數量',
    Yi_QianShou: '已簽收',
    BenCi_QianShou: '本次簽收',
    QianShou_ShiJian: '簽收時間',
    ShenPi_Zhong: '審批中',
    Dai_QianShou: '待簽收',
    Yi_WanCheng: '已完成',
    BoHui: '駁回',
    Yi_ZuoFei: '已作廢',
    DiaoZheng_RenYuan: '調整人員',
    ShenHe_RenYuan: '審核人員',
    DiaoZheng_Qian_KuCun: '調整前庫存',
    DiaoZheng: '調整',
    DiaoZheng_Hou_KuCun: '調整後庫存',
    XiangMu_MingCheng: '項目名稱',
    ZhongLei: '種類',
    JiFei: '計費',
    HanLiang: '含量',
    ChongZhi_JinE: '充值金額',
    ZengSong_JinE: '贈送金額',
    ShiFou_ShouChong: '是否首充',
    YuE: '餘額',
    GuiGe: '規格',
    JingMai: '經脈',
    XueWei: '穴位',
    FangFa: '方法',
    WeiZhi: '位置',
    DanWei: '單位',
    XiangMu: '項目',
    ZiTou: '字頭',
    RiQi_GeShi: '日期格式',
    BuLing: '補零',
    QiShi: '起始',
    LeiXing: '類型',
    ShuLiang: '數量',
    KeHu_BianHao: '客戶編號',
    JiuZhen: '就診',
    HeJi: '合計',
    XueWei_GeShu: '穴位個數',
    DanJu_LeiXing: '單據類型',
    ShiYong_CiShu: '使用次數',
    YouHui_JinE_XianZhi: '優惠金額限制',
    ZhongYi_ChuFang: '中醫處方',
    ZhongYi_ChuFang_Zhen: '中醫處方(針)',
    ZhongYi_ChuFang_Tui: '中醫處方(推)',
    ZhongYi_ChuFang_Ba: '中醫處方(拔)',
    BingLi_BaoGao: '病歷報告',
    BingJia_ZhengMingShu: '病假證明書',
    DaoZhen_ZhengMingShu: '到診證明書',
    HuaiYun_ZhengMingShu: '懷孕證明書',
    ShouJu: '收據',
    ZhuanJie_Xin: '轉介信',
    DaYin_ShiJian: '打印時間',
    DaYin_Ren: '打印人',
    DaYin_ZhenSuo: '打印診所',
    GuanLiYuan: '管理員',
    Biaozhun: '標準',
    GuiGe_BianMa: '規格編碼',
    PinYin: '拼音',
    YaoPing_GuiGe: '藥品規格',
    NongDu: '濃度',
    ShiFou_NongSuo: '是否濃縮',
    TiaoMa: '條碼',
    PiCiHao: '批次號',
    HuiYuan_MiaoShu: '會員描述',
    HuiYuan_MiaoShu_En: '描述（En）',
    GuiShu_ZhenSuo: '歸屬診所',
    CaiDan: '菜單',
    MoRen_DanWei_ChengBenjia: '默認單位成本價',
    MoRen_DanWei_ShouJia: '默認單位售價',
    DingDan_YaoPing_ShuLiang: '採購數量',
    XiangMu_ShuLiang: '項目數量',
    DingGou_Zong_ShuLiang: '訂購總數量',
    YaoFang: '藥方',
    ShiFou_GongKai: '是否公開',
    ChuangJian_Ren: '創建人',
    YingXiao_LeiXing: '營銷類型',
    DingJia_FangShi: '定價方式',
    HuoDong_JiaGe: '活動價格',
    HuoDong_ZheKou: '活動折扣',
    HuoDong_ShangPin: '活動商品',
    Xiang_JinE: '現金額',
    BianDong_JinE: '變動金額',
    ErWeiMa: '二維碼',
    FaFang_CiShu: '發放次數',
    YaoPin_PiHao: '藥品批號',
    CaiGou: '採購',
    PanDian: '盤點',
    BianDong_Qian_KuCun: '變動前庫存',
    BianDong_Zhi: '變動值',
    BianDong_Hou_KuCun: '變動後庫存',
    LaiYuan_DanJuHao: '來源單據號',
    CaoZuo_RenYuan: '操作人員',
    CaoZuo_ShiJian: '操作時間',
    HuanZhe_BianHao: '患者編號',
    YuYue_ShiJian: '預約時間',
    TuiJian_YuanYin: '推薦原因',
  },
}
